import { GET_LATLNG_FROM_PINCODE } from './constants';

export interface Response {
    results: Result[];
    status: string;
}

export interface Result {
    address_components: AddressComponent[];
    formatted_address: string;
    geometry: Geometry;
    place_id: string;
    postcode_localities: string[];
    types: string[];
}

export interface AddressComponent {
    long_name: string;
    short_name: string;
    types: string[];
}

export interface Geometry {
    bounds: Bounds;
    location: Location;
    location_type: string;
    viewport: Viewport;
}

export interface Bounds {
    northeast: Northeast;
    southwest: Southwest;
}

export interface Northeast {
    lat: number;
    lng: number;
}

export interface Southwest {
    lat: number;
    lng: number;
}

export interface Location {
    lat: number;
    lng: number;
}

export interface Viewport {
    northeast: Northeast2;
    southwest: Southwest2;
}

export interface Northeast2 {
    lat: number;
    lng: number;
}

export interface Southwest2 {
    lat: number;
    lng: number;
}

export default (pincode: string): Promise<Response> => {
    return fetch(GET_LATLNG_FROM_PINCODE(pincode)).then((res) => res.json());
};
